
import {Component, Mixins, Prop} from 'vue-property-decorator';
import {authentication} from "@pazion/pazion-core/src/store";
import BaseMixin from "@pazion/pazion-core/src/mixins/base.mixin";
import {IS_PRODUCTION} from "@pazion/pazion-core/src/config";
import PermissionService from "@pazion/pazion-core/src/services/permission-service";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import DataDialog from "@pazion/pazion-core/src/components/utils/DataDialog.vue";

@Component({
  components: {PazTooltipButton, DataDialog}
})
export default class PazFooter extends Mixins(BaseMixin, PermissionService) {

  @Prop({default: false})
  showFooterInfo!: boolean;

  public dataDialog: boolean = false;

  getVersion() {
    return this.$applicationVersion || 'not found.';
  }

  get isConnected() {
    return authentication.isUserLoggedIn;
  }

  get showDevTooltip(): boolean {
    return !IS_PRODUCTION;
  }

  get getApiUrl() {
    return authentication.getApiUrl;
  }

  get activeUsername() {
    if (this.getProfile() != null) {
      return this.getProfile()?.name ?? '';
    }
    return '';
  }

  get doShowUserSpecs() {
    if (authentication.backupUser != null) {
      return true;
    }
    return this.getProfile()?.roles.includes('administrator') ?? false;
  }

  get activeRole() {
    if (this.getProfile() != null) {
      return this.getProfile()?.roles[0] ?? '';
    }
    return '';
  }

  getProfile() {
    return authentication.getProfile;
  }
}
